// extracted by mini-css-extract-plugin
export default {"rating":"AB-z","numberOfStars":"BB-z","count":"CB-z","barGraphSpacing":"DB-z","barGraph":"EB-z"};